package com.milta.core.localization.translations.fr

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Photo",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "envoyée à l'instant",
    fileWaitingConnectionLabel = "en attente de connexion",
    analysingTitle = "Lecture du document…",
    analysingSubtitle = "L'extraction des livraisons peut prendre quelques secondes.",
    analysingSubtitlePdf = "Claude Haiku extrait les livraisons — peut prendre quelques secondes sur un PDF scanné.",
    stepFileSent = "Fichier envoyé",
    stepExtracting = "Extraction des champs",
    stepReview = "Relecture avant ajout",
    successTitle = "Livraison détectée",
    successSubtitle = "Vérifiez les informations avant de les ajouter à la tournée.",
    addToRouteButton = "Ajouter à la tournée",
    scanAnotherButton = "Scanner un autre document",
    partialTitle = "Presque complet",
    partialSubtitle = "Un champ n'a pas pu être lu sur le document.",
    missingFieldPlaceholder = "À compléter…",
    partialBannerText = "Certaines informations n'ont pas pu être lues. Vous pouvez valider tel quel et les compléter plus tard, ou reprendre un document plus net.",
    retryFileButton = "Reprendre un autre fichier",
    validateAndContinueButton = "Valider et continuer",
    attemptLabel = "Tentative",
    errorTitleUnreadable = "Document illisible",
    errorTitleMissingFields = "Informations introuvables",
    errorTitleNetworkError = "Problème lors de l'analyse",
    errorTitleGeneric = "Échec de l'analyse",
    errorSubtitle = "Nous n'avons pas pu détecter de livraison sur ce fichier.",
    errorBannerSuffixUnreadable = "image trop sombre ou texte coupé. Reprenez une photo cadrée et bien éclairée, ou renvoyez un fichier plus net.",
    errorBannerSuffixMissingFields = "aucune information exploitable n'a été trouvée. Vérifiez le contenu du fichier ou renvoyez-en un autre.",
    errorBannerSuffixNetworkError = "le service d'analyse a rencontré un problème réseau. Réessayez dans quelques instants.",
    errorBannerSuffixGeneric = "une erreur inattendue est survenue pendant l'analyse. Réessayez ou renvoyez un autre fichier.",
    retryWithNewFileButton = "Réessayer avec un autre fichier",
    manualEntryButton = "Saisir manuellement",
    attemptsRemainingNote = "Il vous reste 1 tentative pour ce document.",
    maxAttemptsTitle = "Toujours illisible",
    maxAttemptsSubtitle = "Ce document n'a pas pu être analysé après 2 tentatives.",
    maxAttemptsBanner = "Limite de tentatives atteinte pour ce document. Complétez la livraison manuellement, ou reprenez l'import depuis le début avec un nouveau document.",
    retryUnavailableButton = "Réessayer — indisponible",
    newDocumentButton = "Importer un nouveau document",
    serviceUnavailableTitle = "Service temporairement indisponible",
    serviceUnavailableSubtitle = "L'analyse automatique ne répond pas pour le moment.",
    serviceUnavailableBanner = "Réessayez dans quelques instants, ou complétez la livraison manuellement en attendant.",
    offlineTitle = "Vous êtes hors connexion",
    offlineSubtitle = "Votre fichier est prêt mais n'a pas encore été envoyé.",
    offlineBanner = "Reconnectez-vous à Internet puis relancez l'analyse. Rien n'a été envoyé au serveur — aucune tentative n'est comptée.",
    retryOfflineButton = "Réessayer — pas de connexion",
    unsupportedFormatBanner = "Format de fichier non supporté. Choisissez une photo, un PDF ou un fichier Excel/CSV.",
    validationTitle = "Vérifier les livraisons",
    fileRejectedTitle = "Fichier non envoyé",
    fileRejectedSubtitle = "Choisissez un autre fichier pour continuer.",
    bannerFileRequired = "aucun fichier n'a été sélectionné. Choisissez un fichier PDF pour continuer.",
    bannerInvalidPdfFormat = "format non supporté. Seuls les fichiers PDF sont acceptés ici.",
    bannerFileTooLarge = "fichier trop volumineux. Choisissez un fichier PDF plus léger.",
    chooseAnotherFileButton = "Choisir un autre fichier",
)
